import React, { useEffect, useState } from 'react';
import { Home, Mail, MessageCircle, Search, UserRound } from 'lucide-react';
// import { BookOpen, NotebookTabs, Target } from 'lucide-react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { db } from '../firebase';
import { useAuth } from '../AuthContext';
import { Logo } from './UI';

export default function Layout({ children, authPage = false }) {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user?.uid) return undefined;
    const conversations = query(collection(db, 'conversations'), where('participants', 'array-contains', user.uid));
    return onSnapshot(conversations, (snapshot) => setUnread(snapshot.docs.reduce((total, item) => total + Number(item.data().unreadCountByUser?.[user.uid] || 0), 0)));
  }, [user?.uid]);

  const item = ({ isActive }) => `nav-link ${isActive ? 'active' : ''}`;
  return (
    <div className={`app-shell ${authPage ? 'app-shell--auth' : ''}`}>
      <aside className="sidebar">
        <Link to="/" className="brand-link"><Logo /></Link>
        <nav>
          <NavLink to="/" end className={item}><Home size={20} /><span>Home</span></NavLink>
          <NavLink to="/people" className={item}><Search size={20} /><span>People</span></NavLink>
          <NavLink to="/messages" className={item}><Mail size={20} /><span>Messages</span>{unread > 0 && <b className="badge">{unread > 99 ? '99+' : unread}</b>}</NavLink>
          <NavLink to="/clubs" className={item}><MessageCircle size={20} /><span>Community circles</span></NavLink>
          {/* <NavLink to="/goals" className={item}><Target size={20} /><span>Goals</span></NavLink>
          <NavLink to="/goal-book" className={item}><NotebookTabs size={20} /><span>Goal Book</span></NavLink> */}
          <NavLink to="/profile" className={item}><UserRound size={20} /><span>Profile</span></NavLink>
          {/* <NavLink to="/library" className={item}><BookOpen size={20} /><span>Reading library</span></NavLink> */}
        </nav>
      </aside>
      <main className="main-content">{children || <Outlet />}</main>
      <nav className="mobile-nav">
        <NavLink to="/" end className={item}><Home /><span>Home</span></NavLink>
        <NavLink to="/people" className={item}><Search /><span>People</span></NavLink>
        <NavLink to="/messages" className={item}><Mail />{unread > 0 && <b className="badge">{unread > 9 ? '9+' : unread}</b>}<span>Messages</span></NavLink>
        <NavLink to="/clubs" className={item}><MessageCircle /><span>Circles</span></NavLink>
        <NavLink to="/profile" className={item}><UserRound /><span>Profile</span></NavLink>
      </nav>
    </div>
  );
}

export function PageHeader({ eyebrow, title, children }) {
  return <header className="page-header"><Link to="/" className="mobile-header-logo" aria-label="Area home"><Logo compact /></Link><div className="page-header-copy">{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h1>{title}</h1></div>{children && <div className="page-actions">{children}</div>}</header>;
}
